export const state={
  // menu
  isMenu:true,
  isSceneTrans:false,
  // glb
  currentID:0,
  sceneIDs:[],
  nextScene:null,
  direction:null,
  contentAreaHeight:0,
  freeScrollPos:0,
  backToFixedArea:true,
  // whale
  whaleSceneCurrentID:0,
  // content
  inContentArea:false,
}
